export default __webpack_public_path__ + "static/media/contact1.8120e7ec.png";